import _uniqBy from "lodash.uniqby";
//import _orderby from "lodash.orderby";

export default {
  UPDATE_PAGE_CACHE(state, payload) {
    if (typeof Storage !== "undefined") {
      payload.version = state.storeVersion;
      localStorage.setItem(state.cacheKey, JSON.stringify(payload));
    }
  },
  SET_NAVIGATION_STATUS(state, payload) {
    state.isOpenNav = payload;
  },
  CHANGE_LOGO_VISIBILITY(state, payload) {
    state.logoVisible = payload;
  },
  SET_USER_CHANGE_NAVI(state, payload) {
    state.userOpenNav = payload;
  },
  LOADED_EVERYTHING(state, payload) {
    state.loadedEverything = payload;
  },
  PAGE_IS_LOADING(state, payload) {
    state.pageIsLoading = payload;
  },
  UPDATE_APP_VERSION(state, payload) {
    state.storeVersion = payload;
  },

  STORE_LOADED_TAXONOMIES(state, payload) {
    if (payload) {
      Object.keys(payload).forEach(keyTax => {
        payload[keyTax].forEach(taxData => {
          if (!state.taxonomies[keyTax])
            state.taxonomies = { ...state.taxonomies, ...{ [keyTax]: [] } };
          if (state.taxonomies[keyTax]) {
            state.taxonomies[keyTax].filter((item, key) => {
              if (taxData.id === item.id)
                state.taxonomies[keyTax][key] = taxData;
            });
          }
          state.taxonomies[keyTax].push(taxData);
          let filtered = _uniqBy(state.taxonomies[keyTax], "id");
          if (filtered) state.taxonomies[keyTax] = filtered;
        });
      });
    }
  },
  STORE_AUTHOR(state, payload) {
    state.authors.push(payload);
    //just in case remove duplicates
    let filtered = _uniqBy(state.authors, "id");
    if (filtered) state.authors = filtered;
  },
  /**
   *
   * @param {state} state Just state
   * @param {array} payload Payload what should be save,
   */
  STORE_PAGE_DATA(state, payload) {
    if (payload && payload[0]) {
      payload.forEach(post => {
        let postType = post.type ? post.type : "revisions";
        if (!state.postsData[postType])
          state.postsData = { ...state.postsData, ...{ [postType]: [] } };
        if (state.postsData[postType]) {
          // replace freshly laoded page if it is same as previous one, eg after enter password
          state.postsData[postType].filter((item, key) => {
            if (post.id === item.id) {
              state.postsData[postType][key] = post;
            }
          });
        }
        state.postsData[postType].push(post);
        let filtered = _uniqBy(state.postsData[postType], "id");
        //update meta ... we're already downlaoded it so :D
        if (filtered) state.postsData[postType] = filtered;
      });
      //filtered = _orderby(filtered, 'date', 'desc');
    }
  }
};
